module.exports = __webpack_public_path__ + "img/12.a4c7b9ec.png";